class LanguagePicker extends HTMLElement {
    constructor() {
        super();

        this.bindShowList();
        this.bindHideList();
        this.bindSubmit();
    }

    bindShowList() {
        this.querySelector('.show-lang-list').addEventListener('click', () => {
            this.querySelector('.lang-list-menu').style.display = '';
        });
    }

    bindHideList() {
        document.addEventListener('click', (e) => {
            if (!this.contains(e.target)){
                this.querySelector('.lang-list-menu').style.display = 'none';
            }
        });
    }

    bindSubmit() {
        this.querySelector('.lang-list-menu')
            .querySelectorAll('button')
            .forEach((button) => {
                button.addEventListener('click', () => {
                    this.querySelector('input[name="locale_code"]').value = button.getAttribute('data-iso-code');
                    this.querySelector('form').submit();
                });
            });
    }
}

customElements.define('language-picker', LanguagePicker);